import { z } from 'zod';
import { emailSchema, httpsUrlSchema } from './common';
import { devViewAsInfoSchema } from './dev-view-as';

/** GET /api/v1/me (brief §5.3). */
export const meSchema = z.object({
  id: z.string().min(1),
  email: emailSchema,
  displayName: z.string().min(1),
  roles: z.array(z.object({ id: z.string().min(1), name: z.string().min(1) })),
  permissions: z.array(z.string()),
  avatarUrl: httpsUrlSchema.optional(),
  /** Present while an admin is viewing the app as this user; the app shows the impersonation marker. */
  impersonation: z
    .object({
      sessionId: z.string().min(1),
      actor: z.object({ id: z.string().min(1), displayName: z.string().min(1) }),
      startedAt: z.iso.datetime(),
      expiresAt: z.iso.datetime(),
    })
    .nullable()
    .optional(),
  /**
   * Developer view-as (2026-10-26, additive): present only while the server's TP_DEV_VIEW_AS
   * switch is on (never on LIVE). Without it the app hides Profile › Developer tools.
   */
  devViewAs: devViewAsInfoSchema.optional(),
});
export type Me = z.infer<typeof meSchema>;
